var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEMailClosedEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.292 16.014-7.043 6.49c-.17-.26-.249-.724-.249-1.383V10.87c0-.64.08-1.086.23-1.346zM27 21.121c0 .65-.08 1.105-.24 1.375l-7.023-6.482L26.78 9.55c.14.25.22.696.22 1.318zM24.169 24H8.128c-.957 0-1.614-.149-1.993-.455l7.164-6.621.667.622c.679.613 1.326.892 2.053.892.717 0 1.365-.28 2.053-.892l.657-.622 7.184 6.63c-.329.297-.906.446-1.744.446z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.243 16.487c-.436.409-.816.586-1.224.586-.418 0-.797-.186-1.224-.586l-8.72-8.032C6.402 8.149 6.992 8 7.827 8H23.87c.988 0 1.674.158 2.044.492z",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailClosedEnvelope);
export default __webpack_public_path__ + "static/media/eMail_Closed-Envelope.c91904ca4f564f0f037881b6bdfe8bd5.svg";
export { ForwardRef as ReactComponent };